import React, { useEffect, useState, useCallback, useMemo } from 'react';
import Navbar from '../Components/Navbar';
import Cookies from 'js-cookie'; 
import {
  Box,
  Flex,
  Text,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  useDisclosure,
  useToast,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  HStack,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  InputGroup,
  InputRightElement,
  IconButton,
  Tooltip,
  useClipboard,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  NumberInput,
  Stack
} from '@chakra-ui/react';
import { ExternalLinkIcon, CopyIcon } from '@chakra-ui/icons';
import { useAuth } from "../Components/auth/AuthProvider";
import CustomSpinner from '../Components/CustomSpinner';
import axios from 'axios';
import { format, set } from 'date-fns';

function Account() {



  const toast = useToast();
  const { logOut, user, token } = useAuth();

  const [userData, setUserData] = useState(null);
  const [universityInfo, setUniversityInfo] = useState(null);
  const [businessLoan, setBusinessLoan] = useState(null);

  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');

  const [modalPhoneNumber, setModalPhoneNumber] = useState('');
  const [modalEmail, setModalEmail] = useState('');

  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);
  const [referralCode, setReferralCode] = useState('');

  const [customPayment, setCustomPayment] = useState(10); 
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
  isOpen: isWaveOpen,
  onOpen: onWaveOpen,
  onClose: onWaveClose
} = useDisclosure();
  const baseUrl = process.env.REACT_APP_BACKEND_URL;
  const config = useMemo(() => ({ 
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }), [token]);
  const whatsapp_group = [
    "https://chat.whatsapp.com/GiH1erP8ueqIsy1x6U5CuZ",
    "https://chat.whatsapp.com/CVdaJDkMEaB46MxQm42icG",
    "https://chat.whatsapp.com/BjORK7bhWbf3kCQv4fXm2L"
  ];

  const referDisc = useDisclosure();
  const { isOpen: isRefOpen, onOpen: onRefOpen, onClose: onRefClose } = referDisc;

  const frontendBase = process.env.REACT_APP_FRONTEND_URL || window.location.origin;
  const referralLink = referralCode ? `${frontendBase}/signup?ref=${referralCode}` : '';

  const { hasCopied, onCopy } = useClipboard(referralLink);

  const fetchAllData = useCallback(async () => {
    setLoading(true);
    setLoadingError(false);

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    };

    try {
      const appRes = await axios.get(`${baseUrl}/applications/${user}`, config);
      const applicationData = appRes.data;
      
      setUserData(applicationData);
      setPhoneNumber(applicationData.phone_number);
      setEmail(applicationData.email);
      setModalPhoneNumber(applicationData.phone_number);
      setModalEmail(applicationData.email);
      setReferralCode(applicationData.referral_code);

      const universityId = applicationData.university?.id;

      const parallelRequests = [];

      if (universityId) {
        parallelRequests.push(
          axios.get(`${baseUrl}/universities/${universityId}`, config)
        );
      } else {
        console.warn("University ID is missing or null. Skipping university fetch.");
        parallelRequests.push(Promise.resolve({ data: null }));
      }

     
      parallelRequests.push(
        axios.get(`${baseUrl}/business-loan/student/${user}`, config).catch(error => {
          if (error.response && error.response.status === 404) {
            return { data: null }; 
          }
          throw error;
        })
      );
      
      const [uniRes, loanRes] = await Promise.all(parallelRequests);
      
      if (uniRes) setUniversityInfo(uniRes.data);
      if (loanRes) setBusinessLoan(loanRes.data);

    } catch (err) {
      console.error("Error loading account data:", err.response?.data || err.message);
      setLoadingError(true);
    } finally {
      setLoading(false);
    }
  }, [user, token, baseUrl]);

  useEffect(() => {
    console.log("user from useAuth():", user);
    if (user && token && baseUrl) {
      fetchAllData();
    } else if (!token || !user) {
      setLoading(false);
    }
  }, [user, token, baseUrl, fetchAllData]);

  const handleSaveChanges = async () => {
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const data = {
        phone_number: modalPhoneNumber,
        email: modalEmail,
      };
      const res = await axios.put(`${baseUrl}/applications/${user}`, data, config);

      setUserData(res.data);
      setPhoneNumber(res.data.phone_number);
      setEmail(res.data.email);

      toast({
        title: "Basic Information successfully edited",
        position: "top",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (err) {
      console.error("Error updating info:", err);
      toast({
        title: "Failed to edit application",
        description: err.response?.data?.message || "An unknown error occurred.",
        position: "top",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      onClose();
    }
  };
  
  const universityName = universityInfo?.name || userData?.university_string || 'your university';
  
  const contractInfo = `
    <br>
    <strong>Agreement</strong>
    <br>
    This is an agreement between the technology company known as “Jump Finance”, the educational institution known as ${universityName}, and the student borrower, hereto forward referred to as the “student”.
    <br><br>
    <strong>Description of Framework</strong>
    <br>
    As a result of a successful credit screening from Jump Finance, ${universityName} has enrolled the student in the Spring 2022 semester. As a condition of receiving this enrollment, the student agrees to pay for this tuition in future monthly installments. These repayments will continue until the tuition advance is paid in full. A detailed breakdown of the repayments is below.
    <br><br>
    <strong>Term of Repayment and Penalties for Default</strong>
    <br>
    The repayment structure and schedule can only be amended through a written agreement between the student, ${universityName}, and Jump Finance. If the student defaults during school (meaning s/he does not make a payment of any kind for more than 30 days past the due date), ${universityName} withholds the right to block enrollment, and if student defaults after graduating, ${universityName} withholds the right to nullify earned credentials. If the student receives a Ministry of Higher Education (MOHE) scholarship (or any other type of scholarship) that pays off their past and future ${universityName} tuition payments, outside of their current membership fees the student is released from any future commitment with Jump Finance and will be refunded their tuition advance payments when ${universityName} is paid in full from the scholarship.
    <br><br>
    <strong>One time Jump Finance Application Fee</strong>
    <br>
    ${
      universityInfo?.app_fee_flat === 0
        ? `Jump Finance one time application fee is ${universityInfo?.app_fee_percentage * 100}% of first tuition advance.`
        : `Jump Finance one time application fee is ${universityInfo?.app_fee_flat}.`
    }
    <br><br>
    <strong>Minimum Monthly Fees while studying</strong>
    <br>
    Minimum monthly tuition advance payment while studying: GMD ${universityInfo?.during_studies_min_payment}
    <br>
    Jump Finance monthly membership fee: GMD ${universityInfo?.during_studies_membership_fee}
    <br>
    Total monthly payment while studying: GMD ${universityInfo?.during_studies_min_payment + universityInfo?.during_studies_membership_fee}
    <br><br>
    <strong>Minimum Monthly Fees post graduation</strong>
    <br>
    If the student has not paid off the tuition advance in full after a six month grace period after graduating, the student’s monthly fees will increase, as broken down below:
    <br>
    Minimum monthly tuition advance payment post graduation: GMD ${universityInfo?.after_studies_min_payment}
    <br>
    Jump Finance monthly membership fee: GMD ${universityInfo?.after_studies_membership_fee}
    <br>
    Total monthly payment post graduation: GMD ${universityInfo?.after_studies_min_payment + universityInfo?.after_studies_membership_fee}
    <br><br>
    <strong>Ongoing Relationship</strong>
    <br>
    As part of their commitment to repayment, the student agrees to quarterly check-ins with the Jump Finance team. As part of their commitment to the student’s educational and career success, Jump Finance commits to providing ongoing mentorship in financial literacy, job training, and career building. If repayments are made in a timely and consistent manner, as determined by ${universityName} and Jump Finance, the student can reapply for additional tuition advances to complete their post-secondary studies. To do so, the student may need to go through an additional application process before receiving an additional tuition advance.
    <br><br>
    <strong>Execution of Agreement</strong>
    <br>
    The parties hereby agree to the above terms and that any changes must be completed through a mutually agreed upon written amendment to the above agreement.
    `;


  const renderBusinessLoanStatus = () => {
    if (!businessLoan) {
      return <Text fontSize="sm" color="gray.500">You haven’t submitted a business loan application.</Text>;
    }

    console.log("businessLoan.status:", businessLoan.status);
    switch (businessLoan.status) {
      case 'approved_await_payment':
        return <Text fontSize="sm"> Congratulations, Jump Finance is able to give you a 30 day loan for GMD 5000. To receive this loan, please pay your origination fee of 500 to our WAVE account (+220 237 2175) and then contact Mafugi Bah our Country Director to arrange a meeting to receive your loan disbursement.</Text>;
      case 'rejected':
        return <Text fontSize="sm">Thank you for applying, unfortunately we are not able to offer you a loan at this point, but you can reapply in 3 months.</Text>;
      case 'approved':
        return (
          <>
            <Text fontSize="sm"> Approved</Text>
            <Text fontSize="sm"><strong>Loan Due Date:</strong> {format(new Date(businessLoan.due_date), 'MMMM dd, yyyy')}</Text>
          </>
        );
      case 'pending':
        return <Text fontSize="sm">Thank you for applying, we are reviewing your loan application. Please check back here for updates.</Text>;
      default:
        return <Text fontSize="sm">Your loan has an unrecognized status. Please contact support.</Text>;
    }
  };


  if (loading) {
    return (
      <Box pt="20vh">
        <CustomSpinner />
      </Box>
    );
  }

  if (loadingError || !userData) {
    return (
      <Box p={10} textAlign="center">
        <Text color="red.500" fontSize="lg">Failed to load account data.</Text>
        <Text color="gray.600">Please refresh the page or try again later.</Text>
      </Box>
    );
  }

  async function makeWavePayment(payingAmount) {
    console.log(config)

    axios.post(`${process.env.REACT_APP_BACKEND_URL}/wave_integration/payment_url`, {
      amount: Number(Math.abs(payingAmount)), 
      currency: 'GMD',
      student_id: user
    }, config)
    .then(response => {
      const url = response.data.wave_launch_url 

      Cookies.set('sessionId', response.data.id); 

      if (url) {
        window.open(url, '_blank', 'noopener, noreferrer')
      }
    })
    .catch(error => {
      console.error(error); 
    })

    // Cookies.set('sessionId', "cos-1zafdf85r8111")
  }

  return (
    <div style={{ marginBottom: "96px" }}>
      <Navbar />
      <Box bg="#00D29D" w="100%" h="8vh" display="flex" alignItems="center" justifyContent="center">
        <Text fontSize="16px" fontWeight="semibold" color="white">{userData.first_name}'s Account</Text>
      </Box>

      {/* *** NEW ALERT AT THE TOP *** */}
      {businessLoan?.status === 'open' && (
        <Box mx={{ base: 4, md: 5 }} mt={4}>
            <Alert status="warning" borderRadius="md" variant="solid">
                <AlertIcon />
                <Box>
                    <AlertTitle>Action Required!</AlertTitle>
                    <AlertDescription>
                    Your loan application is ready to proceed. Please pay 10% of the loan amount to finalize the agreement.
                    </AlertDescription>
                </Box>
            </Alert>
        </Box>
      )}

      <Box p="4" boxShadow="lg" borderRadius="2xl" bg="white" mt="8" borderWidth="1px" mx="5">
        <Flex direction="column">
          <Text fontSize="4xl" fontWeight="bold" pl="3">{userData.first_name} {userData.last_name}</Text>

          <Flex mt="4" p="4" borderWidth="1px" borderRadius="2xl" w="100%">
            <Box>
              <Text fontSize="xl" fontWeight="bold" mb="2">Basic Information</Text>
              <Text><b>University:</b> {universityName}</Text>
              <Text><b>Mat Number:</b> {userData.mat_number}</Text>
              <Text><b>Phone Number:</b> {phoneNumber}</Text>
              <Text><b>Email:</b> {email}</Text>
              <Button borderRadius="xl" colorScheme="gray" size="sm" mt="3" onClick={() => {
                setModalPhoneNumber(phoneNumber);
                setModalEmail(email);
                onOpen();
              }}>Edit Info</Button>
            </Box>
          </Flex>

          <Accordion allowToggle mt="4" w="full">
            <AccordionItem>
            <h2>
                <AccordionButton>
                <Box flex="1" textAlign="left" fontWeight="bold">Contract Information</Box>
                <AccordionIcon />
                </AccordionButton>
            </h2>
            <AccordionPanel>
                <Text fontWeight="bold" mb={2}>
                Start Date: {format(new Date(userData.start_date), 'MMMM dd, yyyy')}
                </Text>
                <div dangerouslySetInnerHTML={{ __html: contractInfo }} />
            </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left" fontWeight="bold">Business Loan Status</Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                {renderBusinessLoanStatus()}
              </AccordionPanel>
            </AccordionItem>

            
            {userData.status === 'approved' && universityInfo?.id && (
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box flex="1" textAlign="left" fontWeight="bold">Jump Finance WhatsApp Group</Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel>
                  <Text fontWeight="bold" mb="2">Thank you for paying your application fee and welcome to Jump Finance!</Text>
                  <Text mb="2">Please join the WhatsApp group: {whatsapp_group[universityInfo.id - 1] || 'Contact support for the link.'}</Text>
                  <Text>If you have any questions, message us at: +1 (737) 202-6552</Text>
                </AccordionPanel>
              </AccordionItem>
            )}
          </Accordion>
          <Button bg="#00D29D" flexGrow={1} size="md" onClick={onWaveOpen}>Pay with Wave</Button>
        </Flex>
      </Box>
      <Flex mt="4" ml="8" align="center" justify="space-between" pr="8">
      <HStack spacing={3} align="center">
        <ExternalLinkIcon boxSize={5} />
        <Button borderRadius="2xl" colorScheme="black" size="md" variant="link" onClick={logOut}>
          Sign Out
        </Button>
      </HStack>

  <Button
    borderRadius="xl"
    colorScheme="gray"
    size="sm"
    onClick={onRefOpen}
  >
    Refer a Friend
  </Button>
</Flex>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Edit Basic Information</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb={4}>
              <FormLabel>Phone Number</FormLabel>
              <Input value={modalPhoneNumber} onChange={(e) => setModalPhoneNumber(e.target.value)} />
            </FormControl>
            <FormControl>
              {/* This is the corrected line */}
              <FormLabel>Email</FormLabel>
              <Input value={modalEmail} onChange={(e) => setModalEmail(e.target.value)} />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="green" mr={3} onClick={handleSaveChanges}>Save Changes</Button>
            <Button colorScheme="gray" onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isRefOpen} onClose={onRefClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Share your referral link</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {referralCode ? (
              <>
                <Text fontSize="sm" mb={2}>
                  Send this link to your friend. When they sign up, we’ll credit you automatically.
                </Text>
                <InputGroup>
                  <Input value={referralLink} isReadOnly />
                  <InputRightElement>
                    <Tooltip label={hasCopied ? 'Copied!' : 'Copy to clipboard'}>
                      <IconButton
                        aria-label="Copy referral link"
                        size="sm"
                        icon={<CopyIcon />}
                        onClick={() => {
                          onCopy();
                          toast({
                            title: 'Referral link copied',
                            status: 'success',
                            duration: 1500,
                            isClosable: true,
                            position: 'top',
                          });
                        }}
                      />
                    </Tooltip>
                  </InputRightElement>
                </InputGroup>
              </>
            ) : (
              <Alert status="warning" borderRadius="md">
                <AlertIcon />
                No referral code found for your account. Please contact support.
              </Alert>
            )}
          </ModalBody>
          <ModalFooter>
            <Button onClick={onRefClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isWaveOpen} onClose={onWaveClose}>
      <ModalOverlay />
        <ModalContent>
          <ModalHeader>Select Amount to Deposit with Wave</ModalHeader>
          <ModalBody>
            <Stack spacing = {3}>
              <Button onClick={()=>makeWavePayment(2400)} bg="#00D29D" width="100%" size="md">2400</Button>
              {/* {depositedMinusExpected != null && depositedMinusExpected < 0 ? <Button onClick={()=>makeWavePayment(depositedMinusExpected)} bg="#00D29D" width="100%" size="md">{Math.abs(depositedMinusExpected)}</Button> : null} */}
              <FormControl>
                <InputGroup>
                  <NumberInput width="75%" max={10000} min={10} value={customPayment} onChange={(e)=>setCustomPayment(e)}>
                    <NumberInputField />
                      <NumberInputStepper>
                        <NumberIncrementStepper />
                        <NumberDecrementStepper />
                    </NumberInputStepper>
                  </NumberInput>
                  <InputRightElement width="6rem">
                    <Button bg="#00D29D" h="100%" width="100%"size="sm" onClick={()=>makeWavePayment(customPayment)}>Pay</Button>
                  </InputRightElement>
                </InputGroup>

              </FormControl>
            </Stack>
          </ModalBody>
          <ModalFooter>
            <Button bg="#00D29D" onClick={onWaveClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
    </Modal>
    </div>
  );
}
// Helo
export default Account;
